import AllRoutes from "./AllRoutes";

const PUBLIC_ROUTES: string[] = [AllRoutes.Login, AllRoutes.ForgotPassword];

export default PUBLIC_ROUTES;
